<template>
  <div class="video">
    <!-- 面包屑 -->

    <VideoCategory />
    <!-- 分类关联商品 -->
    <div class="ref-goods">
      <div class="body">
        <VideoItem :lesson="lesson" />
      </div>
    </div>
    <el-pagination
      v-model:current-page="currentPage"
      v-model:page-size="pageSize"
      @size-change="changeSize"
      @current-change="currentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="pageSize"
      background
      layout="total,  prev, pager, next"
      :total="lessonCount"
    >
    </el-pagination>
  </div>
</template>

<script>
import { findLesson } from "@/api/video";
import VideoItem from "./compontents/video-item";
import VideoCategory from "./compontents/video-category.vue";
import { nextTick, ref, watch, onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";
export default {
  name: "Video",
  components: {
    VideoItem,
    VideoCategory,
  },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const lesson = ref([]);
    //总页数
    const lessonCount = ref(0);
    //当前页码
    const currentPage = ref(1);
    //每页数
    const pageSize = ref(16);
    findLesson({
      maID: route.query.maID,
      chID: route.query.firstCate,
      coID: route.query.secondCate,
      clID: route.query.thirdCate,
      size: pageSize.value,
      page: currentPage.value,
    })
      .then((data) => {
        lesson.value = data.result.map((item) => {
          return {
            chID: item.chID,
            maID: item.maID,
            coID: item.coID,
            clID: item.clID,
            leName: item.leName,
            leImg: "http://www.3hvip.cn/web/" + item.leImg,
            coverImg: "http://www.3hvip.cn/web/" + item.coverImg,
            grade: item.grade.find((ele) => ele._id == item.gradeID),
            id: item._id,
          };
        });
        if (data.resultLength.length) {
          lessonCount.value = data.resultLength[0].totalCount;
        }
      })
      .catch((error) => {
        console.log(error);
      });
    watch(currentPage, () => {
      findLesson({
        maID: route.query.maID,
        chID: route.query.firstCate,
        coID: route.query.secondCate,
        clID: route.query.thirdCate,
        size: pageSize.value,
        page: currentPage.value,
      })
        .then((data) => {
          lesson.value = data.result.map((item) => {
            return {
              chID: item.chID,
              maID: item.maID,
              coID: item.coID,
              clID: item.clID,
              leName: item.leName,
              leImg: "http://www.3hvip.cn/web/" + item.leImg,
              coverImg: "http://www.3hvip.cn/web/" + item.coverImg,
              grade: item.grade.find((ele) => ele._id == item.gradeID),
              id: item._id,
            };
          });

          if (data.resultLength.length) {
            lessonCount.value = data.resultLength[0].totalCount;
          }
          /* nextTick(() => {
            
          }); */
        })
        .catch((error) => {
          console.log(error);
        });
    });

    watch(
      () => [route.query, route.fullPath],
      (newValue, oldValue) => {
        (lesson.value = []),
          findLesson({
            maID: route.query.maID,
            chID: route.query.firstCate,
            coID: route.query.secondCate,
            clID: route.query.thirdCate,
            size: pageSize.value,
            page: currentPage.value,
          })
            .then((data) => {
              (lesson.value = []),
                nextTick(() => {
                  lesson.value = data.result.map((item) => {
                    return {
                      chID: item.chID,
                      maID: item.maID,
                      coID: item.coID,
                      clID: item.clID,
                      leName: item.leName,
                      leImg: "http://www.3hvip.cn/web/" + item.leImg,
                      coverImg: "http://www.3hvip.cn/web/" + item.coverImg,
                      grade: item.grade.find((ele) => ele._id == item.gradeID),
                      id: item._id,
                    };
                  });

                  if (data.resultLength.length) {
                    lessonCount.value = data.resultLength[0].totalCount;
                  }
                });
            })
            .catch((error) => {
              console.log(error);
            });
      }
    );

    const currentChange = (page) => {
      try {
        currentPage.value = page;
        scrollToTop();
      } catch (error) {
        console.log(error);
      }
    };
    const changeSize = (size) => {
      try {
        pageSize.value = size;
      } catch (error) {
        console.log(error);
      }
    };
    const scrollToTop = () => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    };
    onMounted(() => {
      if (router.currentRoute.value.path === "/video") {
        // 检查当前路由路径
        scrollToTop(); // 如果是在指定路径，则滚动到顶部
      }
    });
    return {
      lesson,
      lessonCount,
      currentPage,
      pageSize,
      currentChange,
      changeSize,
      scrollToTop,
    };
  },
};
</script>

<style lang="less" scoped>
.video-bread {
  background: @shColor;
  margin-bottom: 15px;
}
.video {
  width: 1240px;
  margin: 0 auto;
}
.ref-goods {
  background-color: #fff;
  margin-top: 20px;
  position: relative;
  .body {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
  }
}
.el-pagination {
  margin-top: 20px;
  //margin-bottom: 15px;
  font-size: 16px;
  //border: #fff 2px dashed;
  justify-content: center;
}
</style>
